import React, { useEffect } from "react";
import PropTypes from "prop-types";
import styles from "./styles.m.css";

const StateElectionResult = () => {
  useEffect(() => {
    const script = document.createElement("script");

    script.src = "https://public.flourish.studio/resources/embed.js";
    script.async = true;

    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);
  return (
    <div className={`${styles["min"]}`}>
      <div className="flourish-embed flourish-cards" data-src="visualisation/5881913" />
    </div>
  );
};

StateElectionResult.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string,
  id: PropTypes.string,
  showTitle: PropTypes.bool
};

export default StateElectionResult;
